export const splitDoctorName = (doctorName) => {
  const parts = doctorName.trim().split(' ');
  const firstName = parts.slice(0, -1).join(' ').trim() || '';
  const lastName = parts.slice(-1).join(' ').trim() || '';
  return { firstName, lastName };
};
